import { ActivatedRoute, Router } from '@angular/router';
import { AppRoute, AppRouteParam, AppRouteQueryParam } from 'src/app/app.route';
import { LoginRoute } from 'src/app/features/login/login.route';
import { AuthenticationStore } from './authentication.store';

export function redirectToVerification(
  router: Router,
  activatedRoute: ActivatedRoute,
  authStore: InstanceType<typeof AuthenticationStore>,
): void {
  const businessUnit = activatedRoute.root.firstChild?.snapshot.paramMap.get(AppRouteParam.BusinessUnit);

  const shareId = authStore.shareId();
  const relationId = authStore.relationId();

  if (!shareId || !relationId) {
    router.navigate(['/', AppRoute.PageNotFound]);
    return;
  }

  router.navigate(['/', businessUnit, AppRoute.Share, AppRoute.Login, LoginRoute.Verification], {
    queryParams: {
      [AppRouteQueryParam.ShareId]: shareId,
      [AppRouteQueryParam.RelationId]: relationId,
    },
  });
}
